// core
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { of, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

// Material
import { matAutocomplete } from '@campfire-nx/material';

// Raptor
import { RaptorActionService } from '../../resources/raptor-action.service';
import { RAPTOR_DEBOUNCE_TIME } from '../../constant/raptor-constants';

@Component({
  selector: 'open-raptor-autocomplete',
  templateUrl: './raptor-autocomplete.component.html',
  styleUrls: ['./raptor-autocomplete.component.scss']
})
export class RaptorAutocompleteComponent implements OnInit, OnDestroy {
  @Input() question!: any;
  @Input() form!: FormGroup;
  @ViewChild(
    'autoCompleteInput',
    { static: false, read: matAutocomplete.MatAutocompleteTrigger }
  ) autoCompleteInput!: matAutocomplete.MatAutocompleteTrigger;

  questionControl: any;
  questionValueWatcher!: Subscription;
  autoCompletePanelCloseWatcher!: Subscription;
  options: any[] = [];
  loading: boolean = false;
  loadingError: boolean = false;
  searchText: string = '';
  optionSelected: boolean = false;

  constructor(private raptorActionService: RaptorActionService) { }

  ngOnInit(): void {
    this.questionControl = this.form.get(this.question.key);

    this.questionValueWatcher = this.questionControl.valueChanges
      .pipe(
        debounceTime(RAPTOR_DEBOUNCE_TIME),
        distinctUntilChanged(),
        tap(() => {
          this.loading = true;
          this.loadingError = false;
          this.searchText = '';
          this.options = [];
          this.optionSelected = false;
        }),
        switchMap((searchValue: any) => {
          if (searchValue && typeof searchValue === 'string' && searchValue.length >= 3) {
            let url = `${this.question.settings.autocomplete_url}?q=${searchValue}`;
            
            this.searchText = searchValue;
            return this.raptorActionService.getAutoCompleteChoices(url);
          } else {
            return of(null);
          }
        }),
      )
      .subscribe((response: any) => {
        if (response) {
          if (Array.isArray(response)) {
            this.options = response;
          } else if (response.error) {
            this.loadingError = true;
          }
        }
        this.loading = false;
      });
  }

  ngAfterViewInit(): void {
    this.autoCompletePanelCloseWatcher = this.autoCompleteInput.panelClosingActions
      .subscribe(() => {
        if (this.questionControl.value && typeof this.questionControl.value === 'string' && !this.optionSelected) {
          this.questionControl.setValue('');
        }
      });
  }

  ngOnDestroy(): void {
    if (this.questionValueWatcher) {
      this.questionValueWatcher.unsubscribe();
    }
    if (this.autoCompletePanelCloseWatcher) {
      this.autoCompletePanelCloseWatcher.unsubscribe();
    }
  }

  displaySelectedItem(selectedItem: any): string {
    return (selectedItem && selectedItem.label) || '';
  }

  onOptionSelect(): void {
    this.optionSelected = true;
  }
}
